// extracted by mini-css-extract-plugin
export var button = "Card-module--button--54d73";
export var card = "Card-module--card--9e5ef";
export var description = "Card-module--description--7ac1d";
export var green20 = "Card-module--green20--1ec7b";
export var green50 = "Card-module--green50--456d7";
export var image = "Card-module--image--736ce";
export var protectivepurple10 = "Card-module--protectivepurple10--3c234";
export var protectivepurple50 = "Card-module--protectivepurple50--eecd1";
export var putty50 = "Card-module--putty50--dbe6b";
export var title = "Card-module--title--28fab";